/**
 * Loading skeletons.
 *
 * **No shimmer sweep.** At 900 rows a shimmer is a strobe — an animation that
 * reads as polish on one card is a photosensitivity hazard on a full product
 * list, and this table is designed to hold nine hundred rows.
 *
 * The geometry must match the real thing exactly, which is why {@link
 * SkeletonRow} takes the same row height constant the table uses rather than a
 * number of its own. A skeleton that is close but not equal produces a visible
 * jump when data arrives, and that jump is what makes a fast load feel slow.
 *
 * **Status dots stay grey until known — never optimistically green.** A dot
 * that guesses "live" and corrects itself has told the user their printed codes
 * are answering when nobody had checked yet, which is the one thing this
 * product must not do casually.
 */
import { createElement } from "react";
import { TABLE_ROW_HEIGHT } from "../table/DataTable.js";
export function Skeleton({ height = 14, width = "100%", className, }) {
    return createElement("span", {
        className: className === undefined ? "pp-skeleton" : `pp-skeleton ${className}`,
        style: { height: `${height}px`, width },
        "aria-hidden": "true",
    });
}
/** A table row placeholder at exactly the real row height. */
export function SkeletonRow({ columns }) {
    return createElement("div", {
        className: "pp-skeleton-row",
        style: { height: `${TABLE_ROW_HEIGHT}px` },
        "aria-hidden": "true",
    }, ...Array.from({ length: columns }, (_, i) => createElement(Skeleton, { key: i, height: 14 })));
}
//# sourceMappingURL=Skeleton.js.map